import NotFound from "@/assets/not-found.svg";
import { ErrorPage } from "@/components/ErrorPage";
import { useTitle } from "@/hooks/useTitle";
import { getRelativeUrl } from "@/utils/getRelativeUrl";
import styled from "@emotion/styled";
import { Loading } from "@repo/skapa";
import { t } from "@repo/translation";
import { FlexDiv } from "@repo/ui";

import { useActiveProject } from "./ActiveProject";
import { ManageProject } from "./ManageProject";

const LoadingContainer = styled(FlexDiv)`
  height: 50vh;
`;

export const ManageProjectLayout = () => {
  const { isLoading, error, opportunity } = useActiveProject();
  useTitle(opportunity ? `Project - ${opportunity.id}` : "Project");

  if (isLoading) {
    return (
      <LoadingContainer justifyContent="center" alignItems="center">
        <Loading text={t("prompt.loading")} />
      </LoadingContainer>
    );
  }

  if (error) {
    return (
      <ErrorPage
        image={<NotFound />}
        link={getRelativeUrl(`/`)}
        buttonText={t("action.back_to_projects")}
        title={t("prompt.project_not_found")}
        description={t("prompt.project_not_found_desc")}
      />
    );
  }

  return <ManageProject />;
};
